import React from "react";
import MasterData from "view/settings/masterdata/MasterData";

const ActionTrackerData = () => {

    const sections = [
        { label: "Category", value: "Category", items: [] },
        { label: "Source", value: "Source", items: [] },
        { label: "Responsible / Owner", value: "Owner", items: [] },
        { label: "Priority", value: "Priority", items: [] },
        { label: "Status", value: "Status", items: [] },
        { label: "Sub Project", value: "SubProject", items: [] },
    ];

    return (
        <MasterData pageTitle="ActionTracker" sections={sections} />
    );
};

export default ActionTrackerData;